export type RoleName =
  | 'SYSTEM_ADMIN'
  | 'CORPORATE_ADMIN'
  | 'CORPORATE_SUPERVISOR'
  | 'CORPORATE_AGENT'
  | 'THIRDPARTY_AGENT';

export interface Role {
  id: string;
  name: RoleName;
  description: string;
}

export interface Organization {
  organizationCode: string;
  organizationName: string;
  stores: unknown[] | null;
}

/**
 * Roles que pueden cambiar de empresa (tenant) en el selector.
 * TODO-DEBT(PERMISSIONS): Reemplazar por campo `permissions` del backend cuando esté disponible.
 */
export const TENANT_SWITCH_ROLES: RoleName[] = ['SYSTEM_ADMIN'];

/**
 * Roles que pueden gestionar templates (sincronizar, aprobar, historial, editar asunto, ver badges pendientes).
 * TODO-DEBT(PERMISSIONS): Reemplazar por campo `permissions` del backend cuando esté disponible.
 */
export const TEMPLATE_MANAGEMENT_ROLES: RoleName[] = ['SYSTEM_ADMIN'];

/**
 * Roles que pueden ver el panel de "Alertas del sistema" del dashboard de Performance de Envíos
 * (Figma node 2696:11025). Temporalmente incluye los 5 roles (a pedido explícito del usuario:
 * "por ahora mostrémoslo a todos, pero definamos el permiso") mientras se confirma el mapeo
 * exacto del rol "Admin"/"SuperAdmin" de Figma (ver plan del módulo dashboard, pregunta abierta
 * Q6) — el gate (`canViewSystemAlerts`) ya está implementado y en uso, solo falta acotar esta
 * lista cuando se resuelva Q6.
 * TODO-DEBT(PERMISSIONS): Reemplazar por campo `permissions` del backend cuando esté disponible.
 */
export const SYSTEM_ALERTS_VIEW_ROLES: RoleName[] = [
  'SYSTEM_ADMIN',
  'CORPORATE_ADMIN',
  'CORPORATE_SUPERVISOR',
  'CORPORATE_AGENT',
  'THIRDPARTY_AGENT',
];

export interface AccountSummary {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  permissions: string[];
  role: Role;
  organizations: Organization[] | null;
  allowedOrganizations: unknown | null;
  teams: unknown[] | null;
  areas: unknown[] | null;
  subAreas: unknown[] | null;
  stores: unknown[] | null;
}

export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'unauthenticated' | 'error';

export interface AuthState {
  status: AuthStatus;
  account: AccountSummary | null;
  error: string | null;
}

export interface AuthRequest {
  firebaseToken: string;
  productCode: string;
}

export interface AuthResponse {
  account: AccountSummary;
}

export interface ErrorResponse {
  message: string;
}
